import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from 'components/ui/button';
import { DafStatusInformerLayout } from './components/DafStatusInformerLayout/DafStatusInformerLayout';
import { getCommercialOffer } from 'api/maf';
import { MafListDemonstration } from './components/MafListDemonstration/MafListDemonstration';
import { useTranslation } from 'hooks';
import { RootState } from 'store';

interface Props {
  currentLegalEntityId: number;
  needDownloadButton?: boolean;
}

export const DafIsReady: FC<Props> = ({
  currentLegalEntityId,
  needDownloadButton,
}) => {
  const getTranslate = useTranslation();
  const history = useHistory();
  const email = useSelector(
    (state: RootState) =>
      state.user?.boarding?.email || state.settings.salesEmail
  );

  return (
    <DafStatusInformerLayout
      title={getTranslate('getStarted.DAFIsReady.label')}
      mainText={getTranslate('getStarted.DAFIsReady.text', {
        email: `<a href="mailto:${email}">${email}</a>`,
      })}
      buttons={
        <>
          <Button
            id='goToDaf'
            status='primary'
            onClick={() =>
              history.push(`/maf?legalEntityId=${currentLegalEntityId}`)
            }
            text={getTranslate('getStarted.fillOut.button')}
          />
          {needDownloadButton && (
            <Button
              id='comOfferDownload'
              status='outline'
              onClick={() => getCommercialOffer()}
              text={getTranslate('getStarted.downloadOffer.button')}
            />
          )}
        </>
      }
      image={<MafListDemonstration />}
    />
  );
};
